import { getErrorCode, getErrorMessage } from '@/api/errors'
import { extractValidationErrors, extractValidationMessage } from '@/lib/validationErrors'

const UNUSABLE_CONNECTION_CODES = ['CONNECTOR_UNAUTHORIZED', 'CONNECTOR_CONNECTION_UNAVAILABLE']
const CONNECTION_VALIDATION_FIELDS = ['ConnectorId', 'AzureDevOpsConnector']

export function isUnusableConnection(error: unknown): boolean {
  const code = getErrorCode(error)

  return code !== undefined && UNUSABLE_CONNECTION_CODES.includes(code)
}

export function isConnectionValidationError(error: unknown): boolean {
  return extractValidationErrors(error)?.some(e => CONNECTION_VALIDATION_FIELDS.includes(e.field)) ?? false
}

export function isConnectionProblem(error: unknown): boolean {
  return isUnusableConnection(error)
    || getErrorCode(error) === 'CONNECTOR_AMBIGUOUS'
    || isConnectionValidationError(error)
}

export function connectionProblemMessage(error: unknown, connectionName?: string): string | undefined {
  if (connectionName && getErrorCode(error) === 'CONNECTOR_UNAUTHORIZED') {
    return `The "${connectionName}" connection has expired, was revoked or is no longer connected. Reconnect it or choose another connection.`
  }

  return getErrorMessage(error) ?? extractValidationMessage(error) ?? undefined
}
